(() => {
  const make = (tag, cls) => {
    const n = document.createElement(tag);
    n.className = cls;
    n.setAttribute('aria-hidden','true');
    return n;
  };

  const svgWrap = (cls, viewBox, markup) => {
    const s = make('span', cls);
    s.innerHTML = '<svg viewBox="' + viewBox + '" focusable="false" aria-hidden="true">' + markup + '</svg>';
    return s;
  };

  const referenceBatUrl = 'https://cdn.shopify.com/s/files/1/0814/9647/3935/files/europe-mark-halloween-reference-bat.png?v=1791391520';

  const makeBat = ({x,y,size,speed,delay,opacity,flap,mobileHide=false}) => {
    const b = make('span','em-bat');
    b.style.setProperty('--x',x);
    b.style.setProperty('--y',y);
    b.style.setProperty('--size',size);
    b.style.setProperty('--speed',speed);
    b.style.setProperty('--delay',delay);
    b.style.setProperty('--opacity',opacity);
    b.style.setProperty('--flap',flap);
    if(mobileHide) b.dataset.mobileHide='true';

    const image = document.createElement('img');
    image.className = 'em-bat__image';
    image.src = referenceBatUrl;
    image.alt = '';
    image.decoding = 'async';
    image.draggable = false;
    image.setAttribute('aria-hidden','true');
    b.append(image);
    return b;
  };

  const makeEmber = (x,y,s,d,delay) => {
    const e = make('span','em-ember');
    e.style.setProperty('--x',x);
    e.style.setProperty('--y',y);
    e.style.setProperty('--s',s);
    e.style.setProperty('--d',d);
    e.style.setProperty('--delay',delay);
    return e;
  };

  const branchMarkup = `
    <path d="M4 18 C28 14 37 19 56 8 C67 2 78 4 91 13 C76 11 69 15 64 23 C75 20 86 24 98 34 C82 28 70 30 58 40 C48 49 37 55 24 61 C34 46 35 33 28 24 C20 15 12 16 4 18 Z" fill="#080301"/>
    <path d="M52 10 C58 0 66 0 72 4 C65 5 61 9 59 16 Z" fill="#080301"/>
    <path d="M78 15 C87 6 98 8 105 15 C95 13 89 16 84 23 Z" fill="#080301"/>
  `;

  const hauntMarkup = `
    <path d="M8 58 L14 34 L24 34 L28 18 L34 34 L42 34 L48 7 L55 34 L62 34 L67 23 L71 34 L80 34 L84 58 Z" fill="#070301"/>
    <rect x="18" y="41" width="5" height="8" fill="#f57b13" opacity=".8"/>
    <rect x="32" y="39" width="5" height="9" fill="#f57b13" opacity=".8"/>
    <rect x="50" y="31" width="5" height="8" fill="#f57b13" opacity=".82"/>
    <rect x="66" y="42" width="5" height="8" fill="#f57b13" opacity=".78"/>
    <path d="M37 58 V49 C37 44 41 42 44 42 C48 42 51 44 51 49 V58 Z" fill="#f26b09" opacity=".86"/>
    <path d="M4 58 H88" stroke="#070301" stroke-width="5" stroke-linecap="round"/>
  `;

  const pumpkinClusterMarkup = `
    <g transform="translate(2 2)">
      <ellipse cx="20" cy="24" rx="15" ry="16" fill="#f45f0c" stroke="#7d2303" stroke-width="1"/>
      <ellipse cx="42" cy="27" rx="13" ry="14" fill="#ff7819" stroke="#8a2804" stroke-width="1"/>
      <ellipse cx="61" cy="23" rx="15" ry="16" fill="#e95308" stroke="#761e02" stroke-width="1"/>
      <path d="M17 10 C16 4 20 2 23 1 C22 6 25 8 24 11 Z" fill="#4f6227"/>
      <path d="M40 14 C39 9 42 7 45 6 C44 10 47 12 46 15 Z" fill="#4f6227"/>
      <path d="M58 9 C57 4 61 2 64 1 C63 6 66 8 65 11 Z" fill="#4f6227"/>
      <g fill="#1d0702">
        <path d="M11 22 L17 18 L19 25 Z"/><path d="M29 22 L23 18 L21 25 Z"/>
        <path d="M14 31 C18 34 22 34 26 31 L24 29 L22 31 L20 29 L18 31 L16 29 Z"/>
        <path d="M35 26 L40 22 L42 28 Z"/><path d="M50 26 L45 22 L43 28 Z"/>
        <path d="M37 34 C41 36 45 36 49 34 L47 32 L45 34 L43 32 L41 34 L39 32 Z"/>
        <path d="M52 21 L58 17 L60 24 Z"/><path d="M70 21 L64 17 L62 24 Z"/>
        <path d="M55 30 C59 33 63 33 67 30 L65 28 L63 30 L61 28 L59 30 L57 28 Z"/>
      </g>
    </g>
  `;

  const buildScene = (header) => {
    header.classList.add('em-halloween-header');
    if (header.querySelector('.em-halloween-scene[data-em-server-scene="true"]')) return;
    header.querySelectorAll('.em-halloween-scene,.em-halloween-garland').forEach(n=>n.remove());

    const scene = make('div','em-halloween-scene');

    scene.append(
      make('span','em-scene-orb'),
      make('span','em-scene-cloud em-scene-cloud--one'),
      make('span','em-scene-cloud em-scene-cloud--two'),
      make('span','em-scene-horizon'),
      svgWrap('em-branch em-branch--left','0 0 110 70',branchMarkup),
      svgWrap('em-branch em-branch--right','0 0 110 70',branchMarkup),
      svgWrap('em-haunt','0 0 92 62',hauntMarkup),

      makeBat({x:'16%',y:'34%',size:'46px',speed:'8.2s',delay:'-1.2s',opacity:'.92',flap:'.62s'}),
      makeBat({x:'31%',y:'66%',size:'31px',speed:'7.1s',delay:'-3.8s',opacity:'.84',flap:'.68s',mobileHide:true}),
      makeBat({x:'48%',y:'26%',size:'40px',speed:'8.8s',delay:'-5.1s',opacity:'.90',flap:'.64s'}),
      makeBat({x:'64%',y:'61%',size:'34px',speed:'7.7s',delay:'-2.7s',opacity:'.86',flap:'.70s'}),
      makeBat({x:'79%',y:'36%',size:'48px',speed:'9.0s',delay:'-4.4s',opacity:'.94',flap:'.60s'}),
      makeBat({x:'92%',y:'24%',size:'28px',speed:'7.3s',delay:'-6.0s',opacity:'.82',flap:'.72s',mobileHide:true}),

      svgWrap('em-pumpkin-cluster em-pumpkin-cluster--left','0 0 80 48',pumpkinClusterMarkup),
      svgWrap('em-pumpkin-cluster em-pumpkin-cluster--right','0 0 80 48',pumpkinClusterMarkup),

      makeEmber('12%','62%','2px','5.6s','-1.3s'),
      makeEmber('27%','24%','1px','6.8s','-3.1s'),
      makeEmber('43%','72%','2px','7.2s','-4.2s'),
      makeEmber('61%','18%','1px','6.1s','-2.4s'),
      makeEmber('74%','70%','2px','7s','-5.1s'),
      makeEmber('88%','34%','1px','6.4s','-1.7s')
    );

    header.append(scene);
  };


  const em_desktop_hover_dropdown_v1 = true;
  const emDesktopHoverMedia = window.matchMedia('(min-width: 1350px) and (hover: hover) and (pointer: fine)');

  const closeDesktopHoverMenus = (except = null) => {
    document.querySelectorAll(
      '.section-header .header-wrapper.em-halloween-header .header__inline-menu > .list-menu--inline > li > header-menu > details[open]'
    ).forEach((details) => {
      if (details !== except) details.removeAttribute('open');
    });
  };

  const bindDesktopHoverMenus = () => {
    const selector =
      '.section-header .header-wrapper.em-halloween-header .header__inline-menu > .list-menu--inline > li > header-menu > details';

    document.querySelectorAll(selector).forEach((details) => {
      if (details.dataset.emHoverBound === 'true') return;
      details.dataset.emHoverBound = 'true';

      const host = details.parentElement;
      const summary = details.querySelector(':scope > summary');
      let closeTimer;

      const openMenu = () => {
        if (!emDesktopHoverMedia.matches) return;
        window.clearTimeout(closeTimer);
        closeDesktopHoverMenus(details);
        details.setAttribute('open', '');
      };

      const closeMenu = () => {
        if (!emDesktopHoverMedia.matches) return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          details.removeAttribute('open');
        }, 110);
      };

      host.addEventListener('mouseenter', openMenu);
      host.addEventListener('mouseleave', closeMenu);

      if (summary) {
        summary.addEventListener('click', (event) => {
          if (!emDesktopHoverMedia.matches) return;
          event.preventDefault();
          openMenu();
        });
      }

      details.addEventListener('focusin', () => {
        if (window.innerWidth < 1350) return;
        window.clearTimeout(closeTimer);
        closeDesktopHoverMenus(details);
        details.setAttribute('open', '');
      });

      details.addEventListener('focusout', (event) => {
        if (window.innerWidth < 1350) return;
        if (!details.contains(event.relatedTarget)) {
          details.removeAttribute('open');
        }
      });
    });

    if (document.documentElement.dataset.emHoverMediaBound !== 'true') {
      document.documentElement.dataset.emHoverMediaBound = 'true';
      emDesktopHoverMedia.addEventListener('change', (event) => {
        if (!event.matches) closeDesktopHoverMenus();
      });
    }
  };

  const init = () => {
    document.querySelectorAll('.section-header .header-wrapper').forEach(buildScene);
    bindDesktopHoverMenus();
  };

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }

  document.addEventListener('shopify:section:load',init);
})();
